import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "src/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-tailwind_primary text-tailwind_primary_foreground hover:bg-tailwind_primary/80",
        secondary: "border-transparent bg-tailwind_secondary text-tailwind_secondary_foreground hover:bg-tailwind_secondary/80",
        destructive:
          "border-transparent bg-tailwind_destructive text-tailwind_destructive_foreground hover:bg-tailwind_destructive/80",
        outline: "text-tailwind_foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
